import { render, staticRenderFns } from "./IconLabelButton.vue?vue&type=template&id=4e731e33&"
import script from "./IconLabelButton.vue?vue&type=script&lang=js&"
export * from "./IconLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports